export default "__VITE_ASSET__nnqyD7bv__"